import { render, staticRenderFns } from "./Scene3.vue?vue&type=template&id=d9e603d2&scoped=true&"
import script from "./Scene3.vue?vue&type=script&lang=js&"
export * from "./Scene3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e603d2",
  null
  
)

export default component.exports